// src/assets/img/Logo60.tsx
import Image from 'next/image';

import selectImg from '@/hooks/useSelectImg';

interface Logo60Props {
  alt: string;
}

const Logo60 = ({ alt }: Logo60Props) => {
  // Définissez vos chemins d'images
  const imgPng = '/logo.png';
  const imgWebp = '/logo.webp';
  const imgJpg = '/logo.jpg';

  // Sélectionnez l'image appropriée
  const selectedImg = selectImg(imgPng, imgWebp, imgJpg);

  return (
    <Image
      src={selectedImg}
      alt={alt || 'Deagle.dev Logo'}
      width={60} // Largeur fixée
      height={60} // Hauteur fixée
      priority // Chargement prioritaire pour les logos critiques
    />
  );
};

export default Logo60;
